module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icn-target-unknown-5e029986fdefd3d82ad3d010522176ab.svg";